import { useState, useEffect } from "react";
import YouTube from "react-youtube";

export default function PlaylistPlayer({
  yt_api_key,
  playlistId,
  videoOptions,
  setYtPlayer,
}) {
  const [videosList, setVideosList] = useState([]);
  const [activeVideo, setActiveVideo] = useState(null);

  const getYTplaylistVideos = async () => {
    try {
      const ytPlaylistURL = `https://www.googleapis.com/youtube/v3/playlistItems?key=${yt_api_key}&playlistId=${playlistId}&part=snippet,id&order=date`;
      const fetchCall = await fetch(ytPlaylistURL);
      const videosJson = await fetchCall.json();
      const videos = [];

      videosJson.items.forEach((vid, idx) => {
        const data = {
          id: vid.snippet.position + 1,
          name: vid.snippet.title,
          videoId: vid.snippet.resourceId.videoId,
        };

        videos.push(data);
      });

      setVideosList(videos);
      setActiveVideo(videos[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (playlistId) {
      getYTplaylistVideos();
    }
  }, [playlistId]);

  const updateActiveVideo = (e) => {
    console.log("On End", e.data);
    setActiveVideo(videosList[activeVideo.id + 1]);
  };

  return (
    <div className="">
      {activeVideo ? (
        <YouTube
          videoId={activeVideo.videoId}
          opts={videoOptions}
          onReady={(e) => setYtPlayer(e.target)}
          onStateChange={(e) => console.log("On StateChange", e.data)}
          onEnd={(e) => updateActiveVideo(e)}
          onError={(e) => console.log("On Error", e.data)}
          className="video"
        />
      ) : (
        <h5>Please wait......</h5>
      )}
    </div>
  );
}
